/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import NumberFormat from "react-number-format";
export const CommissionColumnFormatter = (cellContent, row, rowIndex) => {
  const { transactionFees = 0 } = row;
  const amountFormatter = () => {
    return (
      <NumberFormat
        value={transactionFees}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div>{amountFormatter()}</div>
      <> </>
    </>
  );
};
